import { bn } from 'shared/utils/bignumber'
import { PoolAsset } from 'modules/pools/constants/poolAssets'
import { weiToStr } from '../utils/parseWei'
import { useAssetPairPrice } from './useAssetPairPrice'

export const useLatestPriceUSD = (
  asset: PoolAsset | null | undefined | '',
  amount: number,
) => {
  const assetPriceData = useAssetPairPrice(asset, 'USD')

  const tokenPriceInUsd =
    assetPriceData && weiToStr(assetPriceData.price, assetPriceData.decimals)

  return tokenPriceInUsd ? new bn(tokenPriceInUsd).times(amount) : null
}
